import { IStackdriverConfig } from '../../interfaces/error-handler/stackdriver-config.interface';

export const stackdriverConfig = (env): IStackdriverConfig => ({
  key: env.logging.stackdriver.apiKey,
  projectId: env.logging.stackdriver.projectId,
  service: 'billetexpressen-frontend',
  version: `${env.type} - v${env.version}`,
  disabled: env.logging.stackdriver.disabled,
});
